import * as autoReply from '../services/autoReply';

export default {
  namespace: 'autoReply',

  state: {
    appId: '',
  },

  effects: {
    //模板列表
    *getAppIdList({ payload: { values }, callback }, { call, put }) {
      const response = yield call(autoReply.getAppIdList, values);
      yield put({
        type: 'save',
        payload: {
          appIdList: response?.data,
        },
      });
      if (callback && typeof callback === 'function') {
        return callback(response);
      }
    },
    //模板列表
    *getMiniAppIdList({ payload: { values }, callback }, { call, put }) {
      const response = yield call(autoReply.getMiniAppIdList, values);
      yield put({
        type: 'save',
        payload: {
          appIdList: response?.data,
        },
      });
      if (callback && typeof callback === 'function') {
        return callback(response);
      }
    },
    //自动回复规则列表
    *getAutoReplyRulePage({ payload: { values }, callback }, { call, put }) {
      const response = yield call(autoReply.getAutoReplyRulePage, values);
      yield put({
        type: 'save',
        payload: {
          autoReplyRuleData: response?.data,
        },
      });
      if (callback && typeof callback === 'function') {
        return callback(response);
      }
    },
    //关注后自动回复
    *getAutoReplyPage({ payload: { values }, callback }, { call, put }) {
      const response = yield call(autoReply.getAutoReplyPage, values);
      const autoReplyList = response?.data?.rules;
      yield put({
        type: 'save',
        payload: {
          autoReplyData: response?.data,
          autoReplyList,
        },
      });
      if (callback && typeof callback === 'function') {
        return callback(response);
      }
    },
    //删除模板消息
    *deleteReplyRule({ payload: { values }, callback }, { call }) {
      const response = yield call(autoReply.deleteReplyRule, values);
      if (callback && typeof callback === 'function') {
        return callback(response);
      }
    },
    //同步关注后自动回复规则
    *synSubscribeReply({ callback }, { call, select }) {
      const autoReplyData = yield select(
        (state) => state.autoReply.autoReplyData,
      );
      const autoReplyList = yield select(
        (state) => state.autoReply.autoReplyList,
      );
      const appId = yield select((state) => state.autoReply.appId);
      const id = autoReplyData?.appId || appId;
      const rules = autoReplyList?.map((i) => i.id);
      const values = { ...autoReplyData, appId: id, rules: rules };

      const response = yield call(autoReply.synSubscribeReply, values);
      if (callback && typeof callback === 'function') {
        return callback(response, values);
      }
    },
    //实时检验自动回复是否被应用
    *checkUseReplyRule({ payload: { values }, callback }, { call }) {
      const response = yield call(autoReply.checkUseReplyRule, values);
      if (response) {
        if (callback && typeof callback === 'function') {
          return callback(response);
        }
      }
    },
  },

  reducers: {
    save(state, action) {
      return { ...state, ...action.payload };
    },
  },

  subscriptions: {
    setup({ history }) {
      return history.listen(() => {});
    },
  },
};
